export const JSONContentTypeHeader = { "Content-Type": "application/json" };
